import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=62606f28&scoped=true&"
import script from "./Booking.vue?vue&type=script&lang=ts&"
export * from "./Booking.vue?vue&type=script&lang=ts&"
import style0 from "./Booking.vue?vue&type=style&index=0&id=62606f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62606f28",
  null
  
)

export default component.exports